import { SpotterEmbed, Action } from "@thoughtspot/visual-embed-sdk/react";
import { useThoughtSpotEmbedCommonProps } from "@/thoughtspot";
import { useDataSourceStore } from "@/stores/DataSourceStore";
import { useTheme } from "@/hooks/useTheme";

const visibleActions: Action[] = [
  Action.Pin,
  Action.ResetSpotterChat,
  Action.SpotterFeedback,
  Action.EditPreviousPrompt,
  Action.DeletePreviousPrompt,
  Action.Edit,
  Action.Download,
  Action.DownloadAsCsv,
  Action.DownloadAsXlsx,
  Action.DownloadAsPng,
];

export function Spotter() {
  const selectedDataSourceId = useDataSourceStore((state) => state.spotterDataSourceId);
  const { theme } = useTheme();
  const commonProps = useThoughtSpotEmbedCommonProps();

  if (!selectedDataSourceId) {
    return null;
  }

  return (
    <SpotterEmbed
      {...commonProps}
      key={`spotter-embed-${theme}`}
      className="w-full h-full"
      worksheetId={selectedDataSourceId}
      hideSourceSelection={true}
      visibleActions={visibleActions}
      frameParams={{
        width: "100%",
        height: "100%",
      }}
      searchOptions={{
        searchQuery: "",
        ...commonProps.searchOptions,
      }}
    />
  );
}
